import errorToast from "./errorToast";

export default (vm, err) => {
    if (err.response && err.response.data) {
        if (typeof err.response.data === "string") {
            err.response.data.split(";").forEach((m) => {
                errorToast(vm, m);
            });
        } else if (err.response.data.Message) {
            errorToast(vm, err.response.data.Message);
        } else {
            errorToast(vm, "An unhandled error occurred.");
        }
    } else if (err.message) {
        errorToast(vm, err.message);
    } else {
        errorToast(vm, "An unhandled error occurred.");
    }
};
